import BaseModel from "../base_model.js";
import I18n from "../../base/i18n.js.jsx";
class RawCountryModel extends BaseModel {

  rawListFields() {
    return [
      {
        name: "name",
        displayName: this.fieldDisplayName("name"),
        type: "text",
        sortKey: "transliterated_name"
      },
      {
        name: "isoCode",
        displayName: this.fieldDisplayName("isoCode"),
        type: "text"
      },
      {
        name: "priority",
        displayName: this.fieldDisplayName("priority"),
        type: "boolean",
      }
    ]
  }

  rawFormFields(item = undefined) {
    return [
      {
        name: "name",
        displayName: this.fieldDisplayName("name"),
        type: "text",
        required: true,
        forceNextLine: true
      },
      {
        name: "isoCode",
        displayName: this.fieldDisplayName("isoCode"),
        type: "text",
        required: true,
        forceNextLine: true
      },
      {
        name: "priority",
        displayName: this.fieldDisplayName("priority"),
        type: "boolean",
      }
    ]
  }

  displayValue(item) {
    if(!item) {
      return "";
    }
    if(!item.id) {
      return I18n.t(`${this.i18nScope()}.new`);
    }
    if(!item.name) {
      return `${I18n.t(`${this.i18nScope()}.name`, {count: 1} )} ${item.id}`;
    }
    return item.name;
  }

  i18nScope() {
    return "model.addresses.country";
  }

}
const CountryModel = new RawCountryModel();
export { RawCountryModel, CountryModel }

